import { Decoder, object, string, number, either, constant, iso8601 } from "decoders";

export interface WellLevelRecord {
  wellName: string;
  waterLevelFT: number;
  pumpStatus: "Running" | "Stopped";
  date: Date;
}

export const wellLevelRecordDecoder: Decoder<WellLevelRecord> = object({
  wellName: string,
  waterLevelFT: number,
  pumpStatus: either(constant("Running"), constant("Stopped")),
  date: iso8601,
});
